<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Update Requests</a>
  </div>
  <div class="pure-menu pure-menu-horizontal">
    <ul class="pure-menu-list">
      <li class="pure-menu-item" [ngClass]="{'pure-menu-selected': selected == 0}">
        <a class="pure-menu-link" (click)="assignComponent('updateTransitTimeComponent')">Update Transit
          Time(Upload)</a>
      </li>
      <!--      <li class="pure-menu-item" [ngClass]="{'pure-menu-selected': selected == 1}" >-->
      <!--        <a class="pure-menu-link" (click)="assignComponent('updateTransitTimeComponentOld')">Update Transit Time(Upload -Old)</a>-->
      <!--      </li>-->
      <li class="pure-menu-item" [ngClass]="{'pure-menu-selected': selected == 2}">
        <a class="pure-menu-link" (click)="assignComponent('padTransitTimeComponent')">Update Transit
          Time(Pad)</a>
      </li>
      <li class="pure-menu-item" [ngClass]="{'pure-menu-selected': selected == 3}">
        <a class="pure-menu-link" (click)="assignComponent('updateTransitTimeS3Component')">Update Transit
          Time(S3)</a>
      </li>
      <li class="pure-menu-item" [ngClass]="{'pure-menu-selected': selected == 4}">
        <a class="pure-menu-link" (click)="assignComponent('RemoveLaneTransitTimeUpdateComponent')">
          Remove Lanes</a>
      </li>
    </ul>
  </div>
  <div>
    <ng-container *ngComponentOutlet="desiredComponent"></ng-container>
  </div>

</div>
